import axios from "axios";
import store from '@/store'
import router from "@/router";
import {queryBuilder, filters} from '../class/QueryFilter'

let filtersCopy = JSON.parse(JSON.stringify(filters))


export default {
    namespaced: true,
    state: {
        stepManagerForm: {},
        ...filtersCopy,
    },
    mutations: {
        setBrands(state, brands) {
            state.brands = brands
        },

        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
    },
    actions: {
        createStepManagerWrapperState({commit, state}, form) {
            state.stepManagerForm[form.stepManagerWrapperId] = form
        },
        getStepManagerForm({commit, state}, stepManagerWrapperId) {
            return state.stepManagerForm[stepManagerWrapperId]
        },
    },
    getters: {
        getFilters: (state) => state.filters,
    }
}